import { lazy, type ReactNode, Suspense } from "react";
import { GeneralSimonChat } from "@/features/intelligence/components/GeneralSimonChat";
import { useTranslation } from "@/shared/i18n/LocaleProvider";
import { Clock } from "@/shared/ui/layout/Clock";
import { ConversationColumn } from "@/shared/ui/layout/ConversationColumn";
import type { SimonPanelView } from "@/shared/ui/WorkspaceContext";

export function ShellConversation({
  collapsed,
  mode,
  onToggle,
  view,
  width,
  homeSlot,
  columnRef,
  hiddenRoute,
  showClock = true,
}: {
  collapsed: boolean;
  mode: "home" | "wide" | "beside";
  onToggle: () => void;
  view: SimonPanelView;
  width: number | null;
  homeSlot?: ReactNode;
  columnRef: (element: HTMLElement | null) => void;
  hiddenRoute?: ReactNode;
  showClock?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <ConversationColumn
      ref={columnRef}
      collapsed={collapsed}
      mode={mode}
      onToggle={onToggle}
      labels={{
        open: t("shell.conv.open"),
        collapse: t("shell.conv.collapse"),
        region: t("shell.conv.region"),
      }}
      head={showClock ? <Clock /> : null}
      showHead={mode !== "home"}
      style={
        mode === "beside"
          ? {
              flexBasis: width === null ? DEFAULT_WIDTH : `${width}px`,
              width: width === null ? DEFAULT_WIDTH : `${width}px`,
            }
          : undefined
      }
    >
      {view === "all-chats" ? (
        <Suspense fallback={null}>
          <ChatsListPage placement="column" />
        </Suspense>
      ) : (
        <GeneralSimonChat homeMode={mode === "home"} homeSlot={homeSlot} />
      )}
      {hiddenRoute != null && <div hidden>{hiddenRoute}</div>}
    </ConversationColumn>
  );
}

const DEFAULT_WIDTH = "clamp(320px, 27vw, 420px)";

const ChatsListPage = lazy(async () => ({
  default: (await import("@/features/intelligence/components/ChatsListPage")).ChatsListPage,
}));
